import GeneralService from "./GeneralService";
import { Component } from "react";
import { Session } from "../model_gen/session";

export class SessionService extends Component {
  public static getApplicationSessions(
    applicationId: any,
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/session/application/${applicationId}/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getCompanySessions(
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/session/all/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static setSessionFeedback(
    applicationId: number,
    sessionId: string,
    session: Partial<Session>,
    loadingHandler: any,
    apiKey: string
  ) {
    const encodedSessionId = encodeURIComponent(sessionId);
    return GeneralService.post(
      `/session/application/${applicationId}/session/${encodedSessionId}/feedback`,
      JSON.stringify(session),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getSession(
    applicationId: any,
    sessionId: string,
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: string
  ) {
    const encodedSessionId = encodeURIComponent(sessionId);
    return GeneralService.get(
      `/session/${encodedSessionId}/application/${applicationId}/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAllEvaluationResults(
    offset: number,
    limit: number,
    status: string[],
    companyIds: number[],
    loadingHandler: any,
    apiKey: string
  ) {
    const params = new URLSearchParams();

    if (status && status.length > 0) {
      status.forEach((s) => params.append("status", s));
    }

    if (companyIds && companyIds.length > 0) {
      params.append("company_ids", companyIds.join(","));
    }

    const queryString = params.toString();
    const url = `/session/events/${offset}/${limit}${
      queryString ? "?" + queryString : ""
    }`;

    return GeneralService.get(
      url,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
